import React, { Suspense, lazy, useState, useEffect, useRef } from 'react';
import { Container } from "./styles";
import { Hero } from "../Hero/Hero";

const About       = lazy(() => import("../About/About").then(m => ({ default: m.About })));
const Project     = lazy(() => import("../Project/Project").then(m => ({ default: m.Project })));
const Testimonials= lazy(() => import("../Testimonials/Testimonials").then(m => ({ default: m.Testimonials })));
const Contact     = lazy(() => import("../Contact/Contact").then(m => ({ default: m.Contact })));

/** Renders children only once the sentinel div scrolls within `rootMargin` of the viewport */
function LazySection({ children, height = '500px', id }: { children: React.ReactNode; height?: string; id?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setShow(true); io.disconnect(); } },
      { rootMargin: '200px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} id={id} style={{ minHeight: show ? undefined : height }}>
      {show && children}
    </div>
  );
}

export function Main() {
  return (
    <main>
      <Container>
        <Hero />
        <LazySection height="600px" id="about">
          <Suspense fallback={null}><About /></Suspense>
        </LazySection>
        <LazySection height="1100px" id="project">
          <Suspense fallback={null}><Project /></Suspense>
        </LazySection>
        <LazySection height="500px" id="testimonials">
          <Suspense fallback={null}><Testimonials /></Suspense>
        </LazySection>
        <LazySection height="500px" id="contact">
          <Suspense fallback={null}><Contact /></Suspense>
        </LazySection>
      </Container>
    </main>
  );
}